export default "__VITE_ASSET__CaafG61n__"